/**
 * IDE Context Subcommand
 * Delegates to the main context command logic
 */
import { Command } from 'commander';
import { createContextCommand } from '../context.js';

/**
 * Create context subcommand for IDE group
 * Re-exports the root-level context command so `j ide context` works the same
 */
export function createContextSubcommand(): Command {
    return createContextCommand();
}
